import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Partialled, AuthorizationSchemeService, AuthorizationScheme } from '@mango/core';


@Component({
    selector: 'subcollection',
    templateUrl: './subcollection.component.html',
    styleUrls: ['./subcollection.component.css']
})
export class SubcollectionComponent implements OnInit {

    @Input() title: string;
    @Input() routerLinkComponent: string;
    @Input() newQueryParams: any;
    @Input() dtoType: string;

    authScheme: AuthorizationScheme;

    constructor(private router: Router, private authSchemeService: AuthorizationSchemeService) { 

    }

    ngOnInit(): void {
        this.authScheme = this.authSchemeService.getMyScheme();
    }

    clickItemAdd() {
        if(this.routerLinkComponent != undefined) {
            this.createNewItem(this.newQueryParams);
        }
    }

    createNewItem(preset: Partialled<any> = null) {
        if(preset) {
            let queryParams = { };
            Object.keys(preset).forEach(x => {
                queryParams[x] = typeof(preset[x]) == 'object' ? JSON.stringify(preset[x]) : preset[x];
            });

            this.router.navigate([`/${this.routerLinkComponent}/detail`, 'new'], { queryParams });
        }
        else {
            this.router.navigate([`/${this.routerLinkComponent}/detail`, 'new']);
        }
    }

    canCreate(): boolean {
        return this.authScheme.canCreate(this.dtoType);
    }


}
